// @flow

import * as React from 'react';
import s from './CheckmarkComplete.scss';

type Props = {
  complete: boolean,
}

let circleStyle;
let checkStyle;


export const CheckmarkComplete = (props: Props) => {
  const { complete } = props;

  if (complete) {
    circleStyle = [s.circle, s.circle_loader];
    checkStyle = [s.checkmark, s.draw];
  } else {
    circleStyle = [s.circle];
    checkStyle = [];
  }

  return (
    <div className={circleStyle.join(' ')}>
      <div className={checkStyle.join(' ')}></div>
    </div>
  );
}

export default CheckmarkComplete;
